import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    closeLabel: string;
    title: string;
    prompt: string;
    placeholder: string;
    addDetails: string;
    detailsLabel: string;
    cancel: string;
    submit: string;
    submitSuccess: string;
    submitError: string;
    topics: {
        requestFeature: string;
        suggestion: string;
        love: string;
        badExperience: string;
        confusing: string;
        other: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Close button label */
            closeLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.closeLabel?c=1h3mba94p9xl7", defaultMessage: "Close" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.title?c=5adg65suwfs8", defaultMessage: "Submit Feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Prompt above the topic chips */
            prompt: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.prompt?c=39572o2g00vc5", defaultMessage: "What''s on your mind?" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Details textarea placeholder */
            placeholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.placeholder?c=j8yqfb5q75uk", defaultMessage: "We''d love to hear how Frame.io is working for you, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Details textarea label */
            addDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.addDetails?c=1xx60nce0av7h", defaultMessage: "Add details (required)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the details textarea */
            detailsLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.detailsLabel?c=2x5icme2sk0r4", defaultMessage: "Additional feedback details" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel button */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Submit button */
            submit: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.submit?c=3oyrpob9pgu4z", defaultMessage: "Submit" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success toast shown after feedback is submitted */
            submitSuccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.submitSuccess?c=1315u7p44w81a", defaultMessage: "Thank you! Your feedback directly helps shape product improvements." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error toast shown when feedback submission fails */
            submitError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.submitError?c=3ehy0mcwgync9", defaultMessage: "Sorry, your feedback wasn''t submitted due to an error. Please try again." }));
                },
                enumerable: true,
                configurable: true
            },
            topics: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        requestFeature: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.topics.requestFeature?c=2jck24ch9eo2j", defaultMessage: "Request a feature" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        suggestion: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.topics.suggestion?c=12hqlqkkqyfoy", defaultMessage: "Share a suggestion" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        love: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.topics.love?c=1oulicbl5q2cn", defaultMessage: "Share something I love" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        badExperience: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.topics.badExperience?c=15ukrw53y4fz2", defaultMessage: "Report a bad experience" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        confusing: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.topics.confusing?c=3x33yd699bid", defaultMessage: "Flag something confusing" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        other: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GlobalFeedbackDialog.topics.other?c=2laqhngyo5ihk", defaultMessage: "Other" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
